export const setPolicyLength = (policyLength) => async (dispatch) => {
  dispatch({ type: 'SET_POLICY_LENGTH', payload: policyLength });
};

export const setTypesLength = (typesLength) => async (dispatch) => {
  dispatch({ type: 'SET_TYPES_LENGTH', payload: typesLength });
};
